/**
 * Swaps an element of array T from fromIndex to toIndex. Respects array
 * boundaries, and won't move elements to places that are invalid. Does not
 * mutate. Returns the original instance if anything in the array changed.
 */
export function swapArrayElements<T>(
  arr: T[],
  fromIndex: number,
  toIndex: number
): T[] {
  if (toIndex < 0 || fromIndex < 0) {
    return arr;
  }
  if (toIndex >= arr.length || fromIndex >= arr.length) {
    return arr;
  }
  const copiedArray: T[] = arr.slice(0);
  const from = copiedArray[fromIndex];
  const to = copiedArray[toIndex];
  copiedArray[toIndex] = from;
  copiedArray[fromIndex] = to;
  return copiedArray;
}
